import { css } from '@/styled-system/css';

export const fieldSetStyles = css.raw({
  '& > [data-c11n-component="Legend"]': {
    display: 'block',
    marginBlockEnd: 'tightest',
  },

  '& > [data-c11n-component="FormHelp"]': {
    marginBlockStart: 'tightest',
  },

  // Indent labeled controls only if a legend is present.
  // Using base style instead of variant to ensure this works for composed version.
  '& > [data-c11n-component="Legend"] ~ [data-c11n-component="LabeledControl"]': {
    marginInlineStart: 'tighter',
  },

  // Hide redundant 'required' and 'optional' indicators in labeled controls.
  '& > [data-c11n-component="LabeledControl"] > [data-c11n-component="Label"]:after': {
    content: 'none',
  },
});
